export default __webpack_public_path__ + "static/media/logout.489d2517.svg";